import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import DefaultService from "@/components/DefaultService";
import WhyChooseUs from "@/components/WhyChooseUs";
import ServiceAreas from "@/components/ServiceAreas";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import GlobalBubbles from "@/components/GlobalBubbles";
import Gallery from "@/components/Gallery";

const Home = () => {
  return (
    <main className="min-h-screen text-slate-900 relative" data-testid="home-page">
      <GlobalBubbles count={28} layer="back" />
      <Header />
      <Hero />
      <Services />
      <DefaultService />
      <WhyChooseUs />
      <Gallery />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <QuoteForm />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
